var _mask, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_413_3066",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.604492 1.15039C0.604492 0.598107 1.05221 0.150391 1.60449 0.150391H28.6071C29.1593 0.150391 29.6071 0.598106 29.6071 1.15039V16.6879C29.6071 17.2402 29.1593 17.6879 28.6071 17.6879H1.60449C1.05221 17.6879 0.604492 17.2402 0.604492 16.6879V1.15039Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.604492 1.15039C0.604492 0.598107 1.05221 0.150391 1.60449 0.150391H28.6071C29.1593 0.150391 29.6071 0.598106 29.6071 1.15039V16.6879C29.6071 17.2402 29.1593 17.6879 28.6071 17.6879H1.60449C1.05221 17.6879 0.604492 17.2402 0.604492 16.6879V1.15039Z",
    stroke: "black",
    strokeWidth: 2.6,
    mask: "url(#path-1-inside-1_413_3066)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5225 22.9832L8.68876 22.9832",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1055 22.8225L15.1055 17.3393",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.5d1dbc23ce9bf2b277b9684f9bf49827.svg";
export { ForwardRef as ReactComponent };